import { useQuery, UseQueryOptions } from 'react-query';

import {
  getSearchData,
  GetSearchDataParams,
  ExpectedGetSearchData,
} from '@keaze/web/api/search';

export const useGetSearchDataQuery = (
  params: GetSearchDataParams,
  options?: UseQueryOptions<ExpectedGetSearchData, Error>
) =>
  useQuery<ExpectedGetSearchData, Error>(
    ['search', params],
    () => getSearchData(params),
    options
  );
